import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import FairService from "../../services/config/fair.service";
import { ColorEditor } from '../../components/grid/CustomEditors/ColorEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class Fair extends BaseGrid {
  
    title = 'Etykiety';
    subTitle = 'Zarządzanie etykietami'
  
  
 constructor(public readonly props: BasicGridProps) {
    super(props);
   
    
 }


 
 saveOrderPositions(){
  const tmpDataset = this.reactGrid.dataView.getItems();
  var x=1
  var y=1
  tmpDataset.forEach(element => {
     element.position=x
  
     FairService.editfair(element).catch(error=>{
       console.log(error)
       this.setState((state: State, props: BasicGridProps) => ({
         ...state,
         alertError: "Błąd podczas zapisywania kolejności!"
       }));  
     }).then( data => {
       y=y+1
      
       if (y==x){
         this.setState((state: State, props: BasicGridProps) => ({
           ...state,
           alertInfo: "Poprawnie zapisano kolejność!"
         }));  
         
       }
     })
     x=x+1
   
  });
  

}


 onBeforeMoveRow(){
  //alert('bb')
 }


 onMoveRows(_e: MouseEvent | TouchEvent, args: any){
  const insertedRows = args.rows as number[];
  const insertBefore = args.insertBefore;

  const extractedRows: number[] = [];

  this.reactGrid.dataView.sort(undefined as any, true);

  const tmpDataset = this.reactGrid.dataView.getItems();
  const filteredItems = this.reactGrid.dataView.getFilteredItems();

  const itemOnRight = this.reactGrid.dataView.getItem(insertBefore);
  const insertBeforeFilteredIdx = insertedRows[0]//itemOnRight ? this.reactGrid.dataView.getIdxById(itemOnRight.id) : this.reactGrid.dataView.getItemCount();

  var finalDataset:any = []
  if (insertBeforeFilteredIdx < insertBefore){
  const left = tmpDataset.slice(0, insertBeforeFilteredIdx);
  const right = tmpDataset.slice(insertBeforeFilteredIdx+1, insertBefore);

  const last = tmpDataset.slice(insertBefore, tmpDataset.length);

  const moved = tmpDataset.slice(insertBeforeFilteredIdx, insertBeforeFilteredIdx+1);

  finalDataset = left.concat(right.concat(moved).concat(last));
}else{
  const left = tmpDataset.slice(0, insertBefore);
  const right = tmpDataset.slice(insertBefore, insertBeforeFilteredIdx);

  const last = tmpDataset.slice(insertBeforeFilteredIdx+1, tmpDataset.length);

  const moved = tmpDataset.slice(insertBeforeFilteredIdx, insertBeforeFilteredIdx+1);


  finalDataset = left.concat(moved.concat(right).concat(last));

}
  this.setState((state: State) => {
    return {
      dataset: finalDataset,
    };
  });

 }

setSearchFilter() {
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e: any) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

    this.getfairslookups();
      
   
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        enableRowMoveManager: true,
        rowMoveManager: {
          columnIndexPosition: 0,
          // when using Row Move + Row Selection, you want to move only a single row and we will enable the following flags so it doesn't cancel row selection
          singleRowMove: true,
          disableRowSelection: true,
          cancelEditOnDrag: true,
          width: 30,
          onBeforeMoveRows: this.onBeforeMoveRow.bind(this),
          onMoveRows: this.onMoveRows.bind(this),
  
          // you can change the move icon position of any extension (RowMove, RowDetail or RowSelector icon)
          // note that you might have to play with the position when using multiple extension
          // since it really depends on which extension get created first to know what their real position are
          // columnIndexPosition: 1,
  
          // you can also override the usability of the rows, for example make every 2nd row the only moveable rows,
          // usabilityOverride: (row, dataContext, grid) => dataContext.id % 2 === 1
        },
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editFairApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getFairApiCall(query)},
          postProcess: (response) => {
            this.setState(
              (state: State) => ({ ...state, metrics: response.metrics }),
              () => this.postProcessCallback(response)
            );
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }


  getfairslookups(){
      return FairService.getfairlookups().then(response => {
  
            let tmp1:any = []
            if ((response.data) && (Array.isArray(response.data))){
                tmp1  = response.data
            }
            this.setState((state) => ({
              ...state,
              lookupData : tmp1
            }),  () => {
             
                this.defineGrid()
                
                 i18next.init({
                    lng: 'pl',
                    debug: false,
                    resources: resources
                  }, (err, t) => {
                    i18next.changeLanguage("pl");
                    
                  });
  
              }
            );
  
       
      }
         
      ).catch(
        () => {
          let tmp :any = [];
          this.setState((state, props) => ({
                ...state,
                alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
          }));
          return tmp;
        }
      )
    }
  


  labelValidator :EditorValidator = (value: any) => {
    
    let ready=false
    if (value === null || value === undefined || !value.length) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return { valid: false, msg: 'To pole jest wymagane' };
    }else if (value.length>50) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertErrorMsg: []
      }));
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 50 znaków',
      };

    }else{
      var selectRow =this.reactGrid.slickGrid.getSelectedRows();
      var id=-1
      if (selectRow.length ==1){
        if (this.reactGrid.slickGrid.getDataItem(selectRow[0])){
          id = this.reactGrid.slickGrid.getDataItem(selectRow[0]).id
        }
      }
       FairService.fairExist(value, id).then(response => {
            if (response >0){
              
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Identyfikator etykiety: " + value + " już istnieje!",
                //alertErrorMsg: "Identyfikator etykiety: " + value + " już istnieje!"
              }));
          
            }else{
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertErrorMsg: []
              }));
            }
      }
      ).catch(
        (error) => {
          this.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertError: error
      }));
        }
      )
    }
   
    return { valid: true, msg: '' };
  };

  requiredNameValidator: EditorValidator = (value: any) => {
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    } else if (value.length>200) {
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 200 znaków',
      };
    }
    return { valid: true, msg: '' };
  };


  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let data_projects : any= [];
    let tmp : Column[] = []; 
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'projects'){
        data_projects = item.data; 
      } 
    })

    if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFairFormatter.bind(this) as Formatter
          },    
        }
      );
    }

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
        {
          id: 'label', name: 'Nazwa etykiety', field: 'label', sortable: false, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          //formatter:this.taskTranslateFormatter,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
          editor: {model: Editors.text,
            validator : this.labelValidator,
            maxLength:3,
            compositeEditorFormOrder : 1,
            
          },
          hidden:false,
          minWidth:100
               
        },
        {
          id: 'caption', name: 'Opis', field: 'caption', sortable: false, filterable: true,
          excludeFromColumnPicker: true,
          type: FieldType.string,
          filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
          editor: {model: Editors.text,
            validator : this.requiredNameValidator,
            maxLength:100,
            compositeEditorFormOrder : 2
          }, 
          minWidth:100     
        },
        {
                id: 'project', name: 'Projekt', field: 'project', sortable: false, filterable: true,
                type: FieldType.string,
                filter: {model: Filters.multipleSelect, collection:data_projects, compoundOperatorList: TextOperators},
                editor: {model: Editors.singleSelect,
                  collection: data_projects,
                  massUpdate: true,
                  compositeEditorFormOrder : 6,
                },
                
                minWidth:100
        },
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }


  deleteFairFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Etykieta:</div> <div>${dataContext.label}</div></div>`;
  }

  getFairApiCall(query: string) {
    return FairService.getfairs(query)
  }
  editFairApiCall(data: any) {   
    FairService.editfair(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowej etykiety';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie etykiety - {{label} {caption}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych rekordów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja etykiety'; // 'Editing - {{title}} ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jedną etykietę do edycji!');
      }else{
        alert('Nie wybrano etykiety do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              FairService.addfair(tmp).then(
                  (data) => {
                    this.reactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania etykiety"
                        }));
                      }
                      
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie etykiety: ' + metadata.dataContext.label + '?')) {
        FairService.deletefair(metadata.dataContext.id).then(
          () => {
            this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertInfo: `Usunięto: ${metadata.dataContext.label}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu etykiety: ${metadata.dataContext.label}`,
            }));
          }
        )
        
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = authService.isAdmin() 
    }
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />

              
            </div>
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>

            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.saveOrderPositions()}>
                Zapisz kolejność
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="fair-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(Fair);